import { ArrowDropDown } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, Legend } from "recharts";


const COLORS = ["#109615", "#FFC700", ];

function ReferalByPatient({ propData }) {
    const [data, setData] = useState([]);

    const convert = (thisData) => {
        const newData = [
            { name: "Male", value: thisData.malePatientPercentage },
            { name: "Female", value: thisData.femalePatientPercentage },
            // { name: "PharmC", value: thisData.pharmcPatientPercentage },
            // { name: "PharmD", value: thisData.pharmDPatientPercentage }
        ];
        return newData;
    };

    useEffect(() => {
        if (propData) {
            setData(convert(propData));
        }
    }, [propData]);

    if (!propData) {
        return <div>No data</div>;
    }

    return (
        <div className="w-90 container">
            <div className="bold-text w-100 border-bottom p-b-20">
                Referal By Partners
            </div>
    
            <div style={{ marginBottom: "1rem" }}>
                <PieChart width={250} height={200}>
                    <Pie
                        data={data}
                        cx={100}
                        cy={80} // move pie up to make space for legend
                        innerRadius={53}
                        outerRadius={60}
                        fill="#8884d8"
                        paddingAngle={0}
                        dataKey="value"
                    >
                        {data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                    </Pie>
                    <Legend
                        iconType="circle"
                        layout="horizontal"
                        verticalAlign="bottom"
                        wrapperStyle={{ marginTop: 20 }} // this is key
                    />
                </PieChart>
            </div>
        </div>
    );
    
}

export default ReferalByPatient;

